<template>
  <div class="submit-success">
    <img v-if="windowInfo.img" class="img" :src="windowInfo.img" alt="">
    <div v-if="windowInfo.text" class="textarea">
      <p class="content" v-html="windowInfo.text"></p>
    </div>
    <gkButton v-if="windowInfo.btn_text" color="blue" size="height34" @click="linkTo">{{windowInfo.btn_text}}</gkButton>
  </div>
</template>

<script>
import gkButton from 'gkui/button'

import {
  urlToScheme,
  universalJump
} from '@geekbang/time.sdk'

export default {
  name: 'submit-success',
  components: {
    gkButton
  },
  props: {
    windowInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {

    }
  },
  computed: {
  },
  created () {
  },
  methods: {
    linkTo () {
      const url = this.windowInfo.btn_url
      const scheme = urlToScheme(url)
      universalJump(scheme, url, true)
    }
  }
}
</script>

<style lang="scss" scoped>
.submit-success {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  width: 620px;

  & .img {
    margin-bottom: 28px;
    max-width: 100%;
  }

  & .textarea {
    padding: 36px;
    margin-bottom: 30px;
    width: 100%;
    background: #F6F6F6;
    border-radius: 8px;

    & .content {
      font-size: 16px;
      color: #353535;
      line-height: 24px;
      white-space: pre-wrap;
    }
  }

  & ::v-deep [gk-button] {
    padding: 12px 52px;
    border-radius: 20px;
    font-size: 16px;
  }
}

@media screen and (max-width: 768px) {
  .submit-success {
    width: 100%;
  }
}
</style>
